/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateNoteDto,
  IncidentNotesControllerCreateV1201,
  IncidentNotesControllerCreateV1PathParameters,
  IncidentNotesControllerFindAllV1200,
  IncidentNotesControllerFindAllV1PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class IncidentNotesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all notes for a specific incident
   */

  findAll<TData = IncidentNotesControllerFindAllV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    incidentId,
  }: IncidentNotesControllerFindAllV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/incidents/v1/clients/${clientId}/incidents/${incidentId}/notes`);
  }
  /**
   * @summary Create a new incident note
   */

  create<TData = IncidentNotesControllerCreateV1201>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, incidentId }: IncidentNotesControllerCreateV1PathParameters,
    createNoteDto: CreateNoteDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/incidents/v1/clients/${clientId}/incidents/${incidentId}/notes`, createNoteDto);
  }
}
